import { Component, HostBinding, Input, OnInit, Output, EventEmitter, AfterViewInit, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { SideNavService } from './side-nav.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AuthConfigService } from 'src/app/modules/auth/auth-config.service';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { DeviceInfoService } from 'src/app/services/device-info.service';
import { MatDialog } from '@angular/material/dialog';
import { AssetTreeService } from '../../services/asset-tree.service';

export interface NavItem {
  displayName: string;
  disabled?: boolean;
  iconName: string;
  route?: string;
  children?: NavItem[];
  parent: string;
  expandable? :boolean;
  role?:string;
  checkByName?:string;
}

@Component({
  selector: 'ple-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  @ViewChild('confirmHMIClose') confirmHMIClose: TemplateRef<any>;
  expanded: boolean;
  @HostBinding('attr.aria-expanded') ariaExpanded;
  @Input() item: NavItem;
  @Input() itemList: any;
  @Output() navigationClicked = new EventEmitter();
  @Output() navParentMenuClicked = new EventEmitter();
  @Input() permissions: any;
  @Input() appDrawer: string;
  
  
  isNavOpen: boolean;
  currentRoute: string;
  showItemForRole: boolean = false;
  navigationDisable = true;
  constructor(public navService: SideNavService,
    public router: Router, private permissionService: PermissionService, private deviceInfoService: DeviceInfoService, private dialog: MatDialog, private assetTreeService: AssetTreeService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('permissions') && changes?.permissions?.currentValue) {
      this.permissions = changes?.permissions?.currentValue;
      this.displaySideNav(this.permissions);
    }
  }

  ngOnInit() {
    if (this.permissions)
      this.displaySideNav(this.permissions);

    this.navService.currentUrl.subscribe((url: string) => {
      if (!url) url = this.router.url;

      this.currentRoute = url;
      
      if (this.item.route && url) {
        this.item.expandable = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.item.expandable;
      }
      if (this.item && this.item.children && url) {
        let currentChild: any = this.item.children.filter(child => {
          return `/${child.route}` == url || this.isDependantRoute(child);
        });
        if (currentChild && currentChild.length) {
          this.navService.setParentDisplayName(currentChild[0].parent);
          this.item.expandable = true;
        }
      }

    });

    this.navService.sidenavChangeObs.subscribe((isOpen: boolean) => {
      this.isNavOpen = isOpen ;
      if (isOpen) {
        this.itemList.forEach(element => {
          element.expandable = false;
        });
        this.ariaExpanded = false;
      }
    })
  }


  displaySideNav(permissionsList) {
    if (!(permissionsList && permissionsList.length)) {
      return;
    }
    if (this.item['checkByName']) {
      let permissions = [`view-${this.item['checkByName']}`, `edit-${this.item['checkByName']}`];
      let userPermissions = this.permissionService.getPermissions();
      permissionsList.map((item: any) => {
        if (permissions.indexOf(item.name) > -1) {
          if (item.allow) {
            this.showItemForRole = true;
          }
        }
      });
    } else {
      this.showItemForRole = true;
    }
  }
  exitFromHMITab(){
    this.navigationDisable = false;  
    this.deviceInfoService.setCloseHmiActiveSession(true);
  }

  onItemSelected(item: NavItem) {
    if(this.deviceInfoService.getHmiSessionStarted()){
      let dialogRef = this.dialog.open(this.confirmHMIClose, {
        width: '500px',
        height: 'max-content',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if(!this.navigationDisable){
          this.onItemSelected(item);
        }
      });
    }
    else{
      if(item.displayName === 'Dashboard'){
        this.assetTreeService.setShowAssetTreeNav(this.appDrawer);
        if (JSON.parse(this.appDrawer?.toLowerCase())){
          this.assetTreeService.selectedOrgName = '';
        }
      }
      else{
          this.assetTreeService.setShowAssetTreeNav(false);
      }
      var oldvalue = item.expandable;
      this.itemList.forEach(element => {
        element.expandable = false;
      });

      if (item.parent) {
        this.navService.setParentDisplayName(item.parent);
      }
      else if (item.children && item.children.length) {
        let self = this;
        let currentChild = item.children.filter(function (child) {
          return `/${child.route}` == self.navService.currentUrl.value
        });
        if (currentChild && currentChild.length) {
          this.navService.setParentDisplayName(currentChild[0].parent);
        }
        console.log(currentChild);
        this.navParentMenuClicked.emit();
      }
      else {
        this.navService.setParentDisplayName("");
      }
      if (!item.children || !item.children.length) {
        this.currentRoute = item.route;
        this.router.navigate([item.route]);
        this.navigationClicked.emit();
      }
      if (item.children && item.children.length) {
        item.expandable = !oldvalue;
      }
    }
  }

  checkNavItem(item: NavItem) {
    if (!JSON.parse(this.appDrawer)) {
      this.item.expandable = false;
    }
    return this.router.isActive(item.route, true) ||
      (this.navService.getParentDisplayName() == item.displayName) ||
      this.isDependantRoute(item);
  }

  isDependantRoute(item) {
    if (item.hasOwnProperty('depsRoutes') && item.depsRoutes.length && this.currentRoute) {
      let route = item.depsRoutes.filter(r => {
        return this.currentRoute.includes(r);
      });

      return (route && route.length);
    }
    return false;
  }

  navigationChildClicked() {
    this.navigationClicked.emit();
  }

}
